import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceDocumentUpdateAction from './machineServiceDocumentUpdate.action.json' with { type: 'json' }
import { machineServiceDocumentUpdateInputObject } from '../machineServiceDocumentObject'

const machineServiceDocumentUpdateDefinition = defineAction({
  ...machineServiceDocumentUpdateAction,

  input: machineServiceDocumentUpdateInputObject,
  output: z.object({}),
})

export default machineServiceDocumentUpdateDefinition
